import { request } from "../network/request";
const db = "dn0";
//查询列表
export function getUserManageList(params, page, pageSize) {
    return request({
        url: "pmp/UserManage/list",
        method: "post",
        params: {
            db,
            page,
            pageSize
        },
        data: params
    });
}

export function deleteUserManage(id) {
    return request({
        url: "pmp/UserManage/delete",
        method: "get",
        params: {
            id
        }
    });
}


export function selectDictDataByType(dictType, type) {
    return request({
        url: "system/getDictData",
        method: "get",
        params: {
            dictType,
            type
        }
    });
}

export function saveUserManage(params) {
    return request({
        url: "pmp/UserManage/saveUserManage",
        method: "post",
        data: params
    });
}

export function getUserManageById(params) {
    return request({
        url: "pmp/UserManage/getUserManageById",
        method: "get",
        params
    });
}